import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

import Logger from '../../../lib/Logger';
// import { axiosVBGetCall } from '../../../services/vbApiCall';
import { renderErrorMessage } from '../../../lib/toastMessage';

import { TtsPlanTable } from './ttsPlanTable';
import { UserAmountPlanTable } from './userAmountPlanTable';
import { ResellerAmountPlanTable } from './resellerAmountPlanTable';
import { AmountPlanTable } from './amountPlanTable';
import { axiosGetCall } from 'src/services/apisCall';
import { jwtDecode } from 'jwt-decode';
import { mainResselerId } from 'src/lib/Enums';

const logger = new Logger('userPlansModal');

const BroadcastAmountPlans = ({ user }) => {
  const [ttsData, setTtsData] = useState([]);
  const [credits, setCredits] = useState([]);

  const [assignedPlan, setAssignedPlan] = useState([]);
  const [planWiseCredits, setPlanWiseCredits] = useState([]);
  const [amount, setAmount] = useState([]);

  const [loading, setLoading] = useState(false);

  const getUserUpdatedCredit = async () => {
    try {
      const { data } = await axiosGetCall('VoiceGetUserAmountPlanArrUser', { userId: user?.voiceInfo?.userId });
      setAssignedPlan(data);
    } catch (error) {
      logger.error('DeliveryLogsTable.jsx ,getDeliveryLogs ,deliveryLogs api', error);
      renderErrorMessage(error?.message);
    }
  };

  const getCredits = async () => {
    try {
      let data;
      if (user?.voiceInfo?.userId === mainResselerId) {
        const response = await axiosGetCall('VoicegetAllplans', { userId: user?.parent_userid });
        data = response.data;
      } else {
        const response = await axiosGetCall('VoiceGetUserAmountPlanArrUser', { userId: user?.parent_userid });
        data = response.data;
      }

      setCredits(data);
    } catch (error) {
      logger.error('DeliveryLogsTable.jsx ,getDeliveryLogs ,deliveryLogs api', error);
      renderErrorMessage(error?.message);
    }
  };

  const getAmount = async () => {
    try {
      const { data } = await axiosGetCall('VoicegetCAUserBalance', { userId: user?.voiceInfo?.userId });
      const arr = [
        {
          Validity: data.Validity,
          currentAmount: data.currentAmount,
          reservedAmount: data.reservedAmount,
          totalAmount: data.totalAmount,
        },
      ];
      setAmount(arr);
    } catch (error) {
      logger.error('DeliveryLogsTable.jsx ,getDeliveryLogs ,deliveryLogs api', error);
      renderErrorMessage(error?.message);
    }
  };

  const forceLoad = async () => {
    setLoading(true);
    await getUserUpdatedCredit();
    await getCredits();
    await getAmount();
    setLoading(false);
  };

  useEffect(() => {
    forceLoad();
    //eslint-disable-next-line
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '18px',
        width: '100%',
        overflow: 'hidden',
        height: 'calc(70vh)',
        overflowY: 'scroll',
        scrollbarWidth: 'none',
      }}
    >
      <AmountPlanTable amount={amount} user={user} forceLoad={forceLoad} loading={loading} />
      {/* <Heading>
                Currrent Assign Plan
            </Heading> */}
      <UserAmountPlanTable planWiseCredits={assignedPlan} user={user} forceLoad={forceLoad} loading={loading} />

      {/* <Heading>
                Reseller login Plans
            </Heading> */}
      <ResellerAmountPlanTable
        credits={credits}
        assignedPlan={assignedPlan}
        user={user}
        forceLoad={forceLoad}
        loading={loading}
      />

      {user?.parent_userid === mainResselerId ? (
        <Box sx={{ height: '20px' }}>
          <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
            Note:
          </Typography>
        </Box>
      ) : (
        <Box sx={{ height: '20px' }}>
          <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
            Note: This user is not in the direct hierarchy of the top reseller.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default BroadcastAmountPlans;
